var map = {
	"./Despacito.png": 5335,
	"./Night Changes.jpg": 1146,
	"./alive.jpg": 4573,
	"./avatar.jpg": 9623,
	"./avatar2.jpg": 5956,
	"./cheap.png": 1153,
	"./dusk.jpg": 6656,
	"./everthing.jpg": 3405,
	"./headphones.svg": 6485,
	"./headphonesLogo.svg": 688,
	"./ignite-1600419626-nHn4WXY79q.jpg": 5952,
	"./ignite.jpg": 8489,
	"./left.svg": 8430,
	"./levitating.jpg": 4657,
	"./login.gif": 4348,
	"./logo.png": 2603,
	"./notAvailable.jpg": 4371,
	"./over-my-head-1602154826-mOiKzOJDe6.jpg": 4291,
	"./right.svg": 7695,
	"./searchMusic.svg": 797,
	"./searchMusicDisc.svg": 4634,
	"./searchMusicMp3.svg": 7103,
	"./senorita.jpg": 1496,
	"./shakedown.jpg": 2140,
	"./shape.jpg": 8122,
	"./want-you-feat-sara-skinner-1586956276-s4lOrfrHQj.jpg": 2876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;